import { Portal as ChakraPortal } from '@chakra-ui/react';

type PortalProps = {
  children: React.ReactNode;
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement | null>;
  appendToParentPortal?: boolean;
};

export const Portal = ({
  children,
  portalled = true,
  portalRef,
  appendToParentPortal,
}: PortalProps) => {
  if (!portalled) {
    return <>{children}</>;
  }

  return (
    <ChakraPortal containerRef={portalRef} appendToParentPortal={appendToParentPortal}>
      {children}
    </ChakraPortal>
  );
};
